export default "__VITE_ASSET__sxBwg2B___"